import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import LeadForm from "@/components/LeadForm";
import Reveal, { MaskedLine } from "@/components/Reveal";
import { formOptions } from "@/data/content";

export default function QuotePage({ mode }) {
  const isVisit = mode === "site_visit";
  const [params] = useSearchParams();
  const preset = params.get("type");
  const presetProjectType = formOptions.projectTypes.some((o) => o.value === preset) ? preset : undefined;

  useEffect(() => {
    document.title = isVisit
      ? "Request a Site Visit | Rogers American Construction, Charleston SC"
      : "Request a Quote | Rogers American Construction, Charleston SC";
  }, [isVisit]);

  return (
    <main className="px-6 md:px-12 pt-36 md:pt-44 pb-24 md:pb-32">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="text-xs uppercase tracking-[0.25em] text-accent font-semibold mb-6" data-testid="quote-eyebrow">
            {isVisit ? "Site Visit Request" : "Quote Request"}
          </p>
          <h1 className="font-display font-medium uppercase leading-[0.92] tracking-tighter text-5xl md:text-6xl" data-testid="quote-title">
            <MaskedLine delay={0.1}>{isVisit ? "Walk the site" : "Price the"}</MaskedLine>
            <MaskedLine delay={0.26}>{isVisit ? "with us." : "project."}</MaskedLine>
          </h1>
          <Reveal delay={0.3}>
            <p className="mt-8 text-smoke text-base md:text-lg leading-relaxed max-w-md" data-testid="quote-intro">
              {isVisit
                ? "Pick a timing that works and we will confirm by phone or email within one business day. Evenings and weekends are fine — the schedule bends to yours."
                : "The more you tell us here, the sharper the number. A person — not an autoresponder — reviews every request within one business day."}
            </p>
            <div className="mt-10 border-t border-ink/10 pt-8 space-y-4 text-sm text-smoke">
              <p><span className="text-ink font-semibold">Based in Charleston.</span> Serving all of South Carolina.</p>
              <p><span className="text-ink font-semibold">Licensed &amp; insured.</span> Family owned and operated.</p>
              <p><span className="text-ink font-semibold">Prefer to talk?</span> (843) 296-7438</p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="md:col-span-7">
          <div className="border border-ink/15 p-8 md:p-12 bg-white">
            <LeadForm mode={mode} presetProjectType={presetProjectType} />
          </div>
        </Reveal>
      </div>
    </main>
  );
}
